import React from "react";
import { Parameter } from "domain/entities/parameter";
import MobileDropdownComponent from "presentation/mobile/components/MobileDropdownComponent";
import MobileInputCurrencyComponent from "presentation/mobile/components/MobileInputCurrencyComponent";

interface MultiDayFormSectionProps {
    entryType: "project" | "abscence";
    setEntryType: (type: "project" | "abscence") => void;
    selectedPO: string | null;
    setSelectedPO: (id: string | null) => void;
    poOptions: Parameter[];
    isDeslocacaoOrPrevencao: boolean;
    selectedAbscence: string | null;
    setSelectedAbscence: (id: string | null) => void;
    abscenceOptions: Parameter[];
    hours: number;
    setHours: (hours: number) => void;
    isAbscenceInDays: boolean;
}

export const MultiDayFormSection: React.FC<MultiDayFormSectionProps> = ({
    entryType,
    setEntryType,
    selectedPO,
    setSelectedPO,
    poOptions,
    isDeslocacaoOrPrevencao,
    selectedAbscence,
    setSelectedAbscence,
    abscenceOptions,
    hours,
    setHours,
    isAbscenceInDays,
}) => {
    return (
        <div className="flex flex-column gap-3">
            {/* Segmented Control */}
            <div
                className="flex border-round-lg overflow-hidden"
                style={{ backgroundColor: "#F1F5F9", padding: "3px" }}
            >
                <button
                    type="button"
                    onClick={() => setEntryType("project")}
                    className="flex-1 flex align-items-center justify-content-center gap-2 border-none cursor-pointer py-2 px-3 border-round-md text-sm font-semibold"
                    style={{
                        backgroundColor: entryType === "project" ? "#FFFFFF" : "transparent",
                        color: entryType === "project" ? "#0084D1" : "#64748B",
                        boxShadow: entryType === "project" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                        transition: "all 0.15s ease",
                    }}
                >
                    <i className="pi pi-briefcase text-xs" />
                    <span>Projeto</span>
                </button>
                <button
                    type="button"
                    onClick={() => setEntryType("abscence")}
                    className="flex-1 flex align-items-center justify-content-center gap-2 border-none cursor-pointer py-2 px-3 border-round-md text-sm font-semibold"
                    style={{
                        backgroundColor: entryType === "abscence" ? "#FFFFFF" : "transparent",
                        color: entryType === "abscence" ? "#0084D1" : "#64748B",
                        boxShadow: entryType === "abscence" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                        transition: "all 0.15s ease",
                    }}
                >
                    <i className="pi pi-calendar-times text-xs" />
                    <span>Ausência</span>
                </button>
            </div>

            {/* Aplicação Rápida */}
            <div
                className="border-1 border-round-lg p-3 flex flex-column gap-3"
                style={{ borderColor: "#E2E8F0" }}
            >
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-bolt" style={{ color: "#0084D1" }} />
                    <span className="text-sm font-medium" style={{ color: "#1E293B" }}>
                        Aplicação Rápida
                    </span>
                </div>

                {entryType === "project" && (
                    <div>
                        <label className="text-xs" style={{ color: "#64748B" }}>Projeto/P.O.</label>
                        <MobileDropdownComponent
                            options={poOptions}
                            isValueId={true}
                            fieldNameId="id"
                            label="Seleciona..."
                            fieldName="selectedPO"
                            currentObject={{ selectedPO }}
                            getValue={selectedPO}
                            setValue={(obj: any) => setSelectedPO(obj.selectedPO)}
                            showClear
                        />
                        {isDeslocacaoOrPrevencao && (
                            <span className="text-xs mt-1 block" style={{ color: "#D97706" }}>
                                <i className="pi pi-info-circle mr-1" />
                                Projetos de Deslocação/Prevenção não contabilizam horas (0h).
                            </span>
                        )}
                    </div>
                )}

                {entryType === "abscence" && (
                    <div>
                        <label className="text-xs" style={{ color: "#64748B" }}>Tipo de Ausência</label>
                        <MobileDropdownComponent
                            options={abscenceOptions}
                            isValueId={true}
                            fieldNameId="id"
                            label="Seleciona..."
                            fieldName="selectedAbscence"
                            currentObject={{ selectedAbscence }}
                            getValue={selectedAbscence}
                            setValue={(obj: any) => setSelectedAbscence(obj.selectedAbscence)}
                            showClear
                        />
                    </div>
                )}

                {/* Horas Diárias */}
                <div>
                    <label className="text-xs" style={{ color: "#64748B" }}>
                        {isAbscenceInDays ? "Dias" : "Horas Diárias"}
                    </label>
                    <div className="mt-1">
                        <MobileInputCurrencyComponent
                            fieldName="hours"
                            label={isAbscenceInDays ? "Dias" : "Horas"}
                            mode="decimal"
                            currentObject={{ hours: isAbscenceInDays ? 1 : hours }}
                            getValue={isAbscenceInDays ? 1 : hours}
                            setValue={(obj: any) => setHours(obj.hours)}
                            isDisable={isAbscenceInDays || isDeslocacaoOrPrevencao}
                            suffix={isAbscenceInDays ? "d" : "h"}
                            inputMode="decimal"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};